import React from "react";

export default function CandidateSkills() {
  return <div>CandidateSkills</div>;
}
